import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "./login.css";
import LoadingPages from "./Loading.pages";
import { serverResponse } from "../util/fakeServer";
import { language } from "../languageProvider/language/language";
import { defaultLanguage } from "../helper/utility";
import { requestLogin } from "../helper/nativeBridge";
import InPublishIcona from "../assets/images/icone/InPublish.icona";

// Modalita' app: login, registrazione e recupero password li gestisce l'app.
function AppLogin(props) {
  const { isAuthenticated, loadingProfile } = props.authJWT;
  const location = useLocation();
  const navigate = useNavigate();
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !loadingProfile) {
      navigate(location.state?.referrer || "/leaflet", { replace: true });
    }
  }, [isAuthenticated, loadingProfile, location.state, navigate]);

  if (loadingProfile || isAuthenticated) {
    return <LoadingPages />;
  }

  return (
    <div className="auth-page">
      <div className="auth-page__content">
        {logoError ? (
          <div className="auth-page__logo auth-page__logo--fallback">
            <InPublishIcona />
          </div>
        ) : (
          <img
            className="auth-page__logo"
            src={serverResponse.config.logo_full}
            alt="logo cliente"
            onError={() => setLogoError(true)}
          />
        )}
        <p className="auth-page__app-message">
          {language[defaultLanguage].accedi_dall_app_testo}
        </p>
        <button className="auth-form__submit" type="button" onClick={requestLogin}>
          {language[defaultLanguage].accedi_dall_app}
        </button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps)(AppLogin);
